import Linkedin from 'images/icons/linkedin.svg'
import Twitter from 'images/icons/twitter.svg'
import Instagram from 'images/icons/instagram.svg'

export const SOCIAL_MEDIA_LINKS = {
  email: 'contact@heeds.tech',
  instagram: 'https://www.instagram.com/heeds.tech/',
  linkedin: 'https://br.linkedin.com/company/heeds-technologies',
}

// Heeds owns the CADU (cadu.fit); both sites show the same legal name and
// CNPJ so whichever domain Meta checks, it finds the company.
export const COMPANY = {
  legalName: 'Heeds Tecnologia LTDA',
  cnpj: '42.192.396/0001-66',
  address: 'Av. Bahia, 644, Sala C — João Pessoa/PB — 58030-130',
}

export const SOCIAL_ICONS = [
  { label: Instagram, path: SOCIAL_MEDIA_LINKS.instagram },
  { label: Linkedin, path: SOCIAL_MEDIA_LINKS.linkedin },
  { label: Twitter, path: '#' },
]
